import { useState, useEffect } from 'react';
import { getSrc } from 'components/elements/PictureHelper';

const Image = (props) => {
    const [srcImg, setSrcImg] = useState(null);

    useEffect(() => {
        if ((!srcImg) && props?.img) {
            setSrcImg(getSrc(props.img));
        }
    }, [])
    
    return (
        <img
            data-test-id={props?.dti}
            alt={props?.img?.alt}
            title={props?.img?.title}
            src={srcImg} className={props?.className} />
    )
}

export default Image;